const identifiedBrowser = {};

function identifyBrowser() {
  if (Object.keys(identifiedBrowser).length > 0) {
    return identifiedBrowser;
  }

  identifiedBrowser['chrome'] = /Chrome/i.test(navigator.userAgent) && !/Edg/i.test(navigator.userAgent);
  identifiedBrowser['edge'] = /Edg/i.test(navigator.userAgent);
  identifiedBrowser['safari'] = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  identifiedBrowser['fire-fox'] = /firefox/i.test(navigator.userAgent);
  identifiedBrowser['ios'] = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  identifiedBrowser['touch'] = 'ontouchstart' in window;

  if (identifiedBrowser['safari']) {
    const versionMatch = navigator.userAgent.match(/Version\/([0-9]+)/);
    const version = versionMatch ? versionMatch[1] : null;

    if (version) {
      identifiedBrowser['safariVersion'] = parseInt(version.split('.')[0]);
    }
  }

  return identifiedBrowser;
}

function setBodyTestClass() {
  if (window.location.href.indexOf('env=test') > -1) {
    document.querySelector('body').classList.add('is-test-env');
  }
}

function setBodyClasses() {
  const identifiedBrowser = identifyBrowser();
  for (const browser in identifiedBrowser) {
    if (identifiedBrowser[browser] === true){
      document.querySelector('body').classList.add(`is_${browser}`);

      if (browser === 'safari') {
        const versionNumber = identifiedBrowser['safariVersion'];
        document.querySelector('body').classList.add(`is_safari--${versionNumber}`);
        if (versionNumber < 15) {
          document.querySelector('body').classList.add('is_safari--old');
        }
      }
    }
  }
}

export {identifyBrowser, setBodyClasses, setBodyTestClass};
